<template>
	<div class="page" v-loading="loading">
		<el-breadcrumb>
			<el-breadcrumb-item>康家管理</el-breadcrumb-item>
			<el-breadcrumb-item>资质证明</el-breadcrumb-item>
		</el-breadcrumb>

		<el-tabs v-model="activeName" type="border-card">
			<el-tab-pane label="营业执照" name="first">
				<div v-for="(business,index) in businessList" :key="index">
					<div class="flex">
						<div class="left">
							<p>营业执照：</p>
							<div class="imgbox">
								<el-image class="img" :src="business.img_url" style="width: 181px; height: 262px;"
									fit="contain">
								</el-image>
							</div>
						</div>
						<div class="right">
							<div class="right-l">
								<p>
									<span class="title">统一社会信用代码：</span>
									<span>{{ business.creditCode }}</span>
								</p>
								<p>
									<span class="title">名称：</span>
									<span>{{ business.name }}</span>
								</p>
								<p>
									<span class="title">类型：</span>
									<span>{{ business.type }}</span>
								</p>
								<p>
									<span class="title">法定代表人：</span>
									<span>{{ business.representative }}</span>
								</p>
								<p>
									<span class="title">住所：</span>
									<span>{{ business.residence }}</span>
								</p>
								<p>
									<span class="title">经营范围：</span>
									<span>{{ business.range }}</span>
								</p>
							</div>
							<div class="right-r">
								<p>
									<span class="title">执照有效期：</span>
									<span>{{ business.date }}</span>
								</p>
								<p>
									<span class="title">注册资本：</span>
									<span>{{ business.amount }}</span>
								</p>
								<p>
									<span class="title">成立日期：</span>
									<span>{{ business.createDate }}</span>
								</p>
								<p>
									<span class="title">营业期限：</span>
									<span>{{ business.date }}</span>
								</p>
							</div>
						</div>
						<div class="btn">
							<el-button type="primary" size="mini" @click="onEdit(business.nature,business,index)">修改
							</el-button>
						</div>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="许可证" name="second">
				<div v-for="(medical,ind) in medicalList" :key="ind">
					<div class="flex">
						<div class="left">
							<p>许可证：</p>
							<div class="imgbox">
								<el-image class="imgs" :src="medical.img_url" style="width: 280px; height: 208px;"
									fit="contain">
								</el-image>
							</div>
						</div>
						<div class="right">
							<div class="right-l">
								<p>
									<span class="title">登记号：</span>
									<span>{{ medical.number }}</span>
								</p>
								<p>
									<span class="title">机构名称：</span>
									<span>{{ medical.companyname }}</span>
								</p>
								<p>
									<span class="title">地址：</span>
									<span>{{ medical.address }}</span>
								</p>
								<p>
									<span class="title">诊疗科目：</span>
									<span>{{ medical.subject }}</span>
								</p>
							</div>
							<div class="right-r">
								<p>
									<span class="title">执照有效期：</span>
									<span>{{ medical.rangeDate }}</span>
								</p>
								<p>
									<span class="title">法定代表人：</span>
									<span>{{ medical.representative }}</span>
								</p>
								<p>
									<span class="title">主要负责人：</span>
									<span>{{ medical.director }}</span>
								</p>
							</div>
						</div>
						<div class="btn">
							<el-button type="primary" size="mini" @click="onEdit(medical.nature,medical,ind)">修改
							</el-button>
						</div>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="授权书" name="third">
				<div v-for="(auth,i) in authList" :key="i">
					<div class="flex">
						<div class="left">
							<p>授权书：</p>
							<div class="imgbox">
								<el-image class="images" :src="auth.img_url" style="width: 198px; height: 280px;"
									fit="contain">
								</el-image>
							</div>
						</div>
						<div class="right">
							<div class="right-l">
								<p>
									<span class="title">授权单位：</span>
									<span>{{ auth.unitname }}</span>
								</p>
								<p>
									<span class="title">被授权单位：</span>
									<span>{{ auth.companyname }}</span>
								</p>
								<p>
									<span class="title">授权经销区域：</span>
									<span>{{ auth.area }}</span>
								</p>
								<p>
									<span class="title">授权产品：</span>
									<span>{{ auth.product }}</span>
								</p>
							</div>
							<div class="right-r">
								<p>
									<span class="title">执照有效期：</span>
									<span>{{ auth.datetimes }}</span>
								</p>
								<p>
									<span class="title">授权人：</span>
									<span>{{ auth.authorizer }}</span>
								</p>
								<p>
									<span class="title">授权日期：</span>
									<span>{{ auth.datetime }}</span>
								</p>
							</div>
						</div>
						<div class="btn">
							<el-button type="primary" size="mini" @click="onEdit(auth.nature,auth,i)">修改</el-button>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>

		<div class="subbtn" @click="upload()">上传证明</div>

		<el-dialog :title="dialogTitle" :visible.sync="infoShow" width="50%" @close="resetInfo"
			:close-on-click-modal="false">
			<el-form :model="info" ref="info" label-width="130px" :inline="true" size="small" class="wrap">
				<el-form-item>
					<div v-if="saveType == 1">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">资质性质</span>
						<el-select v-model="info.nature" placeholder="请选择" value-key="label" @change="selectChange">
							<el-option :value="1" label="营业执照"></el-option>
							<el-option :value="2" label="许可证"></el-option>
							<el-option :value="3" label="授权书"></el-option>
						</el-select>
					</div>
					<div v-if="saveType == 2">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">资质性质</span>
						<el-select v-model="info.nature" placeholder="请选择" value-key="label" disabled>
							<el-option :value="1" label="营业执照"></el-option>
							<el-option :value="2" label="许可证"></el-option>
							<el-option :value="3" label="授权书"></el-option>
						</el-select>
					</div>
				</el-form-item>
				<div v-if="info.nature == 1">
					<el-form-item prop="creditCode">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">统一社会信用代码</span>
						<el-input v-model="info.creditCode" style="width: 220px;" maxlength="18"></el-input>
						<p class="tips">请输入13、15、18位字母或数字</p>
					</el-form-item>
					<el-form-item prop="date">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">执照有效期</span>
						<el-date-picker v-model="info.date" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
						</el-date-picker>
						<el-checkbox v-model="info.checked" style="margin-left: 15px;" @change="change">长期</el-checkbox>
						<p class="tips">证照有效截止日期须大于60天，如证照截止日期为长期或无，请勾选长期</p>
					</el-form-item>
					<el-form-item prop="name">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">名称</span>
						<el-input v-model="info.name" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="amount">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">注册资本</span>
						<el-input v-model="info.amount" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="type">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">类型</span>
						<el-input v-model="info.type" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="createDate">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">成立日期</span>
						<el-input v-model="info.createDate" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="representative">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">法定代表人</span>
						<el-input v-model="info.representative" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="residence">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">住所</span>
						<el-input v-model="info.residence" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="range">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">经营范围</span>
						<el-input type="textarea" v-model="info.range" rows="10" style="width: 700px;" autosize>
						</el-input>
					</el-form-item>
					<el-form-item>
						<div class="uploading">
							<span class="must">*</span>
							<el-upload :auto-upload="false" :on-change="onChangeImg" action="#" list-type="picture-card"
								:limit="1" class="avatar-uploader">
								<img v-if="info.img_url" :src="info.img_url" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon" style="color:#007CFF"></i>
							</el-upload>
							<div>
								<p class="tips">
									1.请上传清晰、完整、无遮挡的营业执照
								</p>
								<p class="tips">
									2.要求原件红章清晰，如为复印件需加盖公司公章
								</p>
								<p class="tips">
									3.图片大小不能超过4M，图片格式为jpg、jpeg、png
								</p>
							</div>
						</div>
					</el-form-item>
				</div>
				<div v-if="info.nature == 2">
					<el-form-item prop="number">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">登记号</span>
						<el-input v-model="info.number" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="date">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">执照有效期</span>
						<el-date-picker v-model="info.rangeDate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
						</el-date-picker>
						<el-checkbox v-model="info.checked" style="margin-left: 15px;" @change="change">长期</el-checkbox>
						<p class="tips">证照有效截止日期须大于60天，如证照截止日期为长期或无，请勾选长期</p>
					</el-form-item>
					<el-form-item prop="companyname">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">机构名称</span>
						<el-input v-model="info.companyname" style="width: 220px;"></el-input>
						<p class="tips"></p>
					</el-form-item>
					<el-form-item prop="representative">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">法定代表人</span>
						<el-input v-model="info.representative" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="address">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">地址</span>
						<el-input v-model="info.address" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item prop="director">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">主要负责人</span>
						<el-input v-model="info.director" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="subject">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">诊疗科目</span>
						<el-input type="textarea" v-model="info.subject" rows="10" style="width: 700px;" autosize>
						</el-input>
					</el-form-item>
					<el-form-item>
						<div class="uploading">
							<span class="must">*</span>
							<el-upload :auto-upload="false" :on-change="onChangeImg" action="#" list-type="picture-card"
								:limit="1" class="avatar-uploader">
								<img v-if="info.img_url" :src="info.img_url" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon" style="color:#007CFF"></i>
							</el-upload>
							<div>
								<p class="tips">
									1.请上传清晰、完整、无遮挡的营业执照
								</p>
								<p class="tips">
									2.要求原件红章清晰，如为复印件需加盖公司公章
								</p>
								<p class="tips">
									3.图片大小不能超过4M，图片格式为jpg、jpeg、png
								</p>
							</div>
						</div>
					</el-form-item>
				</div>
				<div v-if="info.nature == 3">
					<el-form-item prop="unitname">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">授权单位</span>
						<el-input v-model="info.unitname" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="date">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">执照有效期</span>
						<el-date-picker v-model="info.datetimes" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
						</el-date-picker>
						<el-checkbox v-model="info.checked" style="margin-left: 15px;" @change="change">长期</el-checkbox>
						<p class="tips">证照有效截止日期须大于60天，如证照截止日期为长期或无，请勾选长期</p>
					</el-form-item>
					<el-form-item prop="companyname">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">被授权单位</span>
						<el-input v-model="info.companyname" style="width: 220px;"></el-input>
						<p class="tips"></p>
					</el-form-item>
					<el-form-item prop="authorizer">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">授权人</span>
						<el-input v-model="info.authorizer" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="area">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">授权经销区域</span>
						<el-input v-model="info.area" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item prop="datetime">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">授权日期</span>
						<el-input v-model="info.datetime" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item prop="product">
						<span class="must">*</span>
						<span style="margin-right: 10px; vertical-align: top;">授权产品</span>
						<el-input type="textarea" v-model="info.product" rows="10" style="width: 700px;" autosize>
						</el-input>
					</el-form-item>
					<el-form-item>
						<div class="uploading">
							<span class="must">*</span>
							<el-upload :auto-upload="false" :on-change="onChangeImg" action="#" list-type="picture-card"
								:limit="1" class="avatar-uploader">
								<img v-if="info.img_url" :src="info.img_url" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon" style="color:#007CFF"></i>
							</el-upload>
							<div>
								<p class="tips">
									1.请上传清晰、完整、无遮挡的营业执照
								</p>
								<p class="tips">
									2.要求原件红章清晰，如为复印件需加盖公司公章
								</p>
								<p class="tips">
									3.图片大小不能超过4M，图片格式为jpg、jpeg、png
								</p>
							</div>
						</div>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer">
				<el-button @click="infoShow=false">取消</el-button>
				<el-button type="primary" @click="subInfo">提交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Qualification',
		data() {
			return {
				loading: false,
				activeName: 'first',
				keyword: '',
				info: {
					nature: '',
					creditCode: '',
					date: '',
					checked: '',
					name: '',
					amount: '',
					type: '',
					createDate: '',
					representative: '',
					residence: '',
					range: '',
					img_url: '',
					number: '',
					rangeDate: '',
					address: '',
					director: '',
					subject: '',
					unitname: '',
					datetimes: '',
					companyname: '',
					authorizer: '',
					area: '',
					datetime: '',
					product: '',
				},
				infoShow: false,
				// fileList: [],
				businessLicense: [],
				businessList: [],
				medicalLicense: [],
				medicalList: [],
				authLicense: [],
				authList: [],
				authorize: [],
				dialogTitle: '',
				saveType: 1,
				key: ''
			}
		},
		methods: {
			getData() {
				this.businessLicense = []
				this.businessList = []
				this.medicalLicense = []
				this.medicalList = []
				this.authLicense = []
				this.authList = []
				this.loading = true
				this.$util.get('merchant/info')
					.then(res => {
						// console.log(res)
						this.loading = false
						if (res.authorize && res.authorize.length > 0) {
							this.authorize = res.authorize
							if (res.authorize[0] && res.authorize[0].length > 0) {
								this.businessLicense = res.authorize[0]
								this.businessLicense.forEach(business => {
									this.businessList.push({
										nature: business.nature,
										creditCode: business.creditCode,
										date: business.date,
										name: business.name,
										amount: business.amount,
										type: business.type,
										createDate: business.createDate,
										representative: business.representative,
										residence: business.residence,
										range: business.range,
										img_url: business.img_url,
									})
								});
								let string;
								for (let i = 0; i < this.businessLicense.length; i++) {
									string = typeof this.businessLicense[i].date;
									if (this.businessLicense[i].date && this.businessLicense[i].date.length > 0) {
										if (string == 'string') {
											this.businessList[i].date = this.businessLicense[i].date
										} else {
											this.businessList[i].date = this.businessLicense[i].date[0] + '  至  ' + this.businessLicense[i].date[1]
										}
									}
								}
							} else {
								this.businessLicense = []
								this.businessList = []
							}
							if (res.authorize[1] && res.authorize[1].length > 0) {
								this.medicalLicense = res.authorize[1]
								this.medicalLicense.forEach(medical => {
									this.medicalList.push({
										nature: medical.nature,
										number: medical.number,
										rangeDate: medical.rangeDate,
										companyname: medical.companyname,
										representative: medical.representative,
										address: medical.address,
										director: medical.director,
										subject: medical.subject,
										img_url: medical.img_url,
									})
								});
								let string1;
								for (let j = 0; j < this.medicalLicense.length; j++) {
									string1 = typeof this.medicalLicense[j].rangeDate;
									if (this.medicalLicense[j].rangeDate && this.medicalLicense[j].rangeDate.length > 0) {
										if (string1 == 'string') {
											this.medicalList[j].rangeDate = this.medicalLicense[j].rangeDate
										} else {
											this.medicalList[j].rangeDate = this.medicalLicense[j].rangeDate[0] + '  至  ' + this.medicalLicense[j].rangeDate[1]
										}
									}
								}
							} else {
								this.medicalLicense = []
								this.medicalList = []
							}
							if (res.authorize[2] && res.authorize[2].length > 0) {
								this.authLicense = res.authorize[2]
								this.authLicense.forEach(auth => {
									this.authList.push({
										nature: auth.nature,
										unitname: auth.unitname,
										datetimes: auth.datetimes,
										companyname: auth.companyname,
										authorizer: auth.authorizer,
										area: auth.area,
										datetime: auth.datetime,
										product: auth.product,
										img_url: auth.img_url,
									})
								});
								let string2;
								for (let k = 0; k < this.authLicense.length; k++) {
									string2 = typeof this.authLicense[k].datetimes;
									if (this.authLicense[k].datetimes && this.authLicense[k].datetimes.length > 0) {
										if (string2 == 'string') {
											this.authList[k].datetimes = this.authLicense[k].datetimes
										} else {
											this.authList[k].datetimes = this.authLicense[k].datetimes[0] + '  至  ' + this.authLicense[k].datetimes[1]
										}
									}
								}
							} else {
								this.authLicense = []
								this.authList = []
							}
						} else {
							this.businessLicense = []
							this.businessList = []
							this.medicalLicense = []
							this.medicalList = []
							this.authLicense = []
							this.authList = []
						}
					})
			},
			upload() {
				this.saveType = 1;
				this.dialogTitle = '新增资质证明';
				this.authorize = [];
				this.infoShow = true;
			},
			selectChange(val) {
				this.info.nature = val;
			},
			change(val) {
				if (this.info.nature == 1) {
					if (val == true) {
						this.info.date = '长期'
					}
				} else if (this.info.nature == 2) {
					if (val == true) {
						this.info.rangeDate = '长期'
					}
				} else if (this.info.nature == 3) {
					if (val == true) {
						this.info.datetimes = '长期'
					}
				}
			},
			resetInfo() {
				this.info = {
					nature: '',
					creditCode: '',
					date: '',
					checked: '',
					name: '',
					amount: '',
					type: '',
					createDate: '',
					representative: '',
					companyname: '',
					residence: '',
					range: '',
					img_url: '',
					number: '',
					rangeDate: '',
					address: '',
					director: '',
					subject: '',
					unitname: '',
					datetimes: '',
					authorizer: '',
					area: '',
					datetime: '',
					product: '',
				}
				this.infoShow = false
			},
			onEdit(nature, row, key) {
				this.dialogTitle = '编辑资质证明信息'
				this.saveType = 2
				if (nature == 1) {
					if (row.date == '长期') {
						this.info.checked = true
					}
					this.info = {
						checked: this.info.checked,
						nature: row.nature,
						creditCode: row.creditCode,
						date: row.date,
						name: row.name,
						amount: row.amount,
						type: row.type,
						createDate: row.createDate,
						representative: row.representative,
						residence: row.residence,
						range: row.range,
						img_url: row.img_url,
					}
					this.key = key
				}
				if (nature == 2) {
					if (row.rangeDate == '长期') {
						this.info.checked = true
					}
					this.info = {
						checked: this.info.checked,
						nature: row.nature,
						number: row.number,
						rangeDate: row.rangeDate,
						companyname: row.companyname,
						representative: row.representative,
						address: row.address,
						director: row.director,
						subject: row.subject,
						img_url: row.img_url,
					}
					this.key = key
				}
				if (nature == 3) {
					if (row.datetimes == '长期') {
						this.info.checked = true
					}
					this.info = {
						checked: this.info.checked,
						nature: row.nature,
						unitname: row.unitname,
						datetimes: row.datetimes,
						companyname: row.companyname,
						authorizer: row.authorizer,
						area: row.area,
						datetime: row.datetime,
						product: row.product,
						img_url: row.img_url,
					}
					this.key = key
				}
				this.infoShow = true
			},
			subInfo() {
				if (this.saveType == 1) {
					if (this.info.nature == 1) {
						this.info = {
							nature: this.info.nature,
							creditCode: this.info.creditCode,
							date: this.info.date,
							name: this.info.name,
							amount: this.info.amount,
							type: this.info.type,
							createDate: this.info.createDate,
							representative: this.info.representative,
							residence: this.info.residence,
							range: this.info.range,
							img_url: this.info.img_url,
						}
						this.businessLicense.push({
							nature: this.info.nature,
							creditCode: this.info.creditCode,
							date: this.info.date,
							name: this.info.name,
							amount: this.info.amount,
							type: this.info.type,
							createDate: this.info.createDate,
							representative: this.info.representative,
							residence: this.info.residence,
							range: this.info.range,
							img_url: this.info.img_url,
						})
						this.authorize.push(this.businessLicense)
					}
					if (this.info.nature == 2) {
						this.info = {
							nature: this.info.nature,
							number: this.info.number,
							rangeDate: this.info.rangeDate,
							companyname: this.info.companyname,
							representative: this.info.representative,
							address: this.info.address,
							director: this.info.director,
							subject: this.info.subject,
							img_url: this.info.img_url,
						}
						this.medicalLicense.push({
							nature: this.info.nature,
							number: this.info.number,
							rangeDate: this.info.rangeDate,
							companyname: this.info.companyname,
							representative: this.info.representative,
							address: this.info.address,
							director: this.info.director,
							subject: this.info.subject,
							img_url: this.info.img_url,
						})
						this.authorize.push(this.medicalLicense)
					}
					if (this.info.nature == 3) {
						this.info = {
							nature: this.info.nature,
							unitname: this.info.unitname,
							datetimes: this.info.datetimes,
							companyname: this.info.companyname,
							authorizer: this.info.authorizer,
							area: this.info.area,
							datetime: this.info.datetime,
							product: this.info.product,
							img_url: this.info.img_url,
						}
						this.authLicense.push({
							nature: this.info.nature,
							unitname: this.info.unitname,
							datetimes: this.info.datetimes,
							companyname: this.info.companyname,
							authorizer: this.info.authorizer,
							area: this.info.area,
							datetime: this.info.datetime,
							product: this.info.product,
							img_url: this.info.img_url,
						})
						this.authorize.push(this.authLicense)
					}
				}
				if (this.saveType == 2) {
					if (this.info.nature == 1) {
						this.businessLicense[this.key] = {
							nature: this.info.nature,
							creditCode: this.info.creditCode,
							date: this.info.date,
							name: this.info.name,
							amount: this.info.amount,
							type: this.info.type,
							createDate: this.info.createDate,
							representative: this.info.representative,
							residence: this.info.residence,
							range: this.info.range,
							img_url: this.info.img_url,
						}
					}
					if (this.info.nature == 2) {
						this.medicalLicense[this.key] = {
							nature: this.info.nature,
							number: this.info.number,
							rangeDate: this.info.rangeDate,
							companyname: this.info.companyname,
							representative: this.info.representative,
							address: this.info.address,
							director: this.info.director,
							subject: this.info.subject,
							img_url: this.info.img_url,
						}
					}
					if (this.info.nature == 3) {
						this.authLicense[this.key] = {
							nature: this.info.nature,
							unitname: this.info.unitname,
							datetimes: this.info.datetimes,
							companyname: this.info.companyname,
							authorizer: this.info.authorizer,
							area: this.info.area,
							datetime: this.info.datetime,
							product: this.info.product,
							img_url: this.info.img_url,
						}
					}
				}
				this.authorize = [this.businessLicense, this.medicalLicense, this.authLicense]
				this.$util.post('merchant/setInfo', {
					authorize: this.authorize
				})
					.then(res => {
						if (res.code == 0) {
							this.getData()
							this.infoShow = false
						} else {
							this.$message(res.msg)
						}
					})
			},
			onChangeImg(file) {
				let fetchForm = new FormData();
				fetchForm.append("file", file.raw);
				this.$util.post("/upload", fetchForm)
					.then((res) => {
						this.info.img_url = res.data
					})
			},
		},
		mounted() {
			this.getData()
		}
	}
</script>

<style scoped>
	.page {
		width: 90%;
	}

	.el-tabs {
		margin-top: 20px;
	}

	.el-date-editor--daterange.el-input__inner {
		width: 265px;
	}

	/deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
		color: #333333;
	}

	.el-tabs--border-card {
		border: none;
		box-shadow: none;
	}

	/deep/ .el-form-item--small .el-form-item__content,
	/deep/ .el-form-item--small .el-form-item__label {
		line-height: 32px;
		margin-left: 20px;
	}

	.flex {
		position: relative;
		/* width: 90%; */
		margin-top: 20px;
		display: flex;
		padding-bottom: 20px;
		border-bottom: 1px solid #EEEEEE;
	}

	.imgbox {
		width: 280px;
		height: 280px;
		border: 1px solid #CCCCCC;
	}

	.imgbox .img {
		margin: 5px 45px;
	}

	.imgbox .imgs {
		margin: 30px 0px;
	}

	.imgbox .images {
		margin: 0px 35px;
	}

	.left {
		display: flex;
		vertical-align: top;
	}

	.left p {
		font-size: 16px;
		font-weight: bold;
		line-height: 22px;
		font-family: PingFang SC;
		color: #888888;
		margin-top: 0px;
		width: 100px;
	}

	.right {
		margin-left: 20px;
		display: flex;
		vertical-align: top;
		width: 100%;
	}

	.right-l,
	.right-r {
		margin-top: -15px;
	}

	.right-l {
		width: 65%;
	}

	.right-l p span:first-child,
	.right-r p span:first-child {
		font-size: 16px;
		/* font-weight: bold; */
		line-height: 22px;
		font-family: PingFang SC;
		color: #333333;

	}

	.right-l p span:last-child,
	.right-r p span:last-child {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 20px;
		color: #333333;
	}

	.btn {
		position: absolute;
		right: 20px;
		bottom: 30px;
	}

	.subbtn {
		width: 88%;
		height: 60px;
		background: #DFEFFF;
		line-height: 60px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #007CFF;
		text-align: center;
		margin: 30px 0px;
	}

	.must {
		color: #F10019;
		font-size: 18px;
		margin-right: 5px;
		margin-left: 10px;
		vertical-align: top;
	}

	.tips {
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 17px;
		color: #F10019;
		margin-left: 22px;
	}

	.uploading {
		display: flex;
		margin-left: 70px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 148px;
		height: 148px;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 148px;
		height: 148px;
		line-height: 148px;
		text-align: center;
	}

	.avatar {
		width: 148px;
		height: 148px;
		display: block;
		margin-left: -1px;
		margin-top: -1px;
	}

	.title {
		text-align: right;
		width: 150px;
		display: inline-block;
	}
</style>